import { Injectable } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import { v4 as uuidv4 } from 'uuid';


@Injectable({
  providedIn: 'root'
})
export class QueryParamDecoratorService {

  private templateStatus: string | null = null;
  private siteId: string | null = null;
  private trackingId: string | null = null;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const queryParams = this.route.snapshot.queryParams;
        let newParams;
        if (queryParams['template-status']) {
          this.templateStatus = queryParams['template-status'];
        }
        if(queryParams['site-id']){
          this.siteId= queryParams['site-id'];
        }
        if (!this.trackingId) {
          this.trackingId = uuidv4();
        }
        newParams = { 'tracking-id': this.trackingId }

        if (this.templateStatus && !queryParams['template-status']) {
          newParams = {...newParams, 'template-status': this.templateStatus}
        }
        if(this.siteId &&  !queryParams['site-id']){
          newParams={...newParams,'site-id': this.siteId};
        }

        this.router.navigate([], {
          queryParams: newParams,
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
    });
  }
}
